import React, { Component } from "react";
import { Link } from "react-router-dom";
// Layout
import { Divider } from 'antd';
import Header from "../layout/header/header1";
import bannerImg from "../../images/robotics-for-good/banner.png";
import { withTranslation } from "react-i18next";

class RoboticsForGoodApplication extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {};
  }

  componentDidMount() { }

  robotics2025Content() {
    return (
      <>
        {/* 📝 Application Process Section */}
        <div className="section-full content-inner bg-white m-t30">
          <div className="container">
            <div className="section-head style-1 text-center">
              <h2 className="title">Application Process</h2>
            </div>
            <div className="row"></div>
            <div className="row">
              <div className="col-lg-12">
                <h4>🎯 Eligibility</h4>
                <ul>
                  <li><strong>Junior Category:</strong> Students born 2012–2016 (ages ~9–13)</li>
                  <li><strong>Senior Category:</strong> Students born 2008–2011 (ages ~14–17)</li>
                  <li><strong>Team Size:</strong> Up to 8 members, with at least one coach/mentor (18+)</li>
                  <li><strong>Mixed-age Teams:</strong> Compete in the category of the oldest participant</li>
                  <small>
                    (Coach/mentor must confirm that all team members’ parents/guardians have submitted Form 3.)
                  </small>
                </ul>
                <br />
                <br />
                <h4>📝 Application Process</h4>
                <h5>Senior Team (ages 14–17):</h5>
                <ul>
                  <li>
                    Teams submit an application before 25th November, 2025 &rarr; Apply here:&nbsp;
                    <a
                      target="_blank"
                      style={{ textDecoration: "underline" }}
                      rel="noopener noreferrer"
                      href="https://docs.google.com/forms/d/e/1FAIpQLSe7UbAeK-2_UrKrLRtaUchsIo9cMHpvCsR_14M1BJwJLzu46A/viewform?usp=dialog"
                    >
                      Form 1 – Senior Team Application
                    </a>
                  </li>
                  <li>
                    One Senior Team of each state will be selected by the end of November 2025.
                  </li>
                  <li>
                    Shortlisted teams will be provided the task sheet to Join the National Final on 25.
                  </li>
                  <li>
                    Parent/Guardian consent is mandatory:&nbsp;
                    <a
                      target="_blank"
                      style={{ textDecoration: "underline" }}
                      rel="noopener noreferrer"
                      href="https://docs.google.com/forms/d/e/1FAIpQLSdDYTcSEFFeZzfectAnGfbfIVeGOK856Nmit-jSyVf5HtdAfw/viewform?usp=dialog"
                    >
                      Form 3 – Parental/Guardian Consent
                    </a>
                    <br />
                    <small>
                      (Coach/mentor must confirm that all team members’ parents/guardians have submitted Form 3.)
                    </small>
                  </li>
                </ul>
                <h5>Junior Team (ages 9–13):</h5>
                <ul>
                  <li>
                    Teams submit an application before 25th November, 2025 &rarr; Apply here:&nbsp;
                    <a
                      target="_blank"
                      style={{ textDecoration: "underline" }}
                      rel="noopener noreferrer"
                      href="https://docs.google.com/forms/d/e/1FAIpQLSdIZgZH-yVb-tk06b8EI4AokAyKCSdyehe4O09auaUS_wy7oQ/viewform?usp=dialog"
                    >
                      Form 2 – Junior Team Application
                    </a>
                  </li>
                  <li>
                    One Junior Team of each state will be selected by the end of November 2025.
                  </li>
                  <li>
                    Shortlisted teams will be provided the task sheet to Join the National Final on 28th March, 2026.
                  </li>
                  <li>
                    Parent/Guardian consent is mandatory for each student:&nbsp;
                    <a
                      target="_blank"
                      style={{ textDecoration: "underline" }}
                      rel="noopener noreferrer"
                      href="https://docs.google.com/forms/d/e/1FAIpQLSdDYTcSEFFeZzfectAnGfbfIVeGOK856Nmit-jSyVf5HtdAfw/viewform?usp=dialog"
                    >
                      Form 3 – Parental/Guardian Consent
                    </a>
                    <br />
                    <small>
                      (Coach/mentor must confirm that all team members’ parents/guardians have submitted Form 3.)
                    </small>
                  </li>
                </ul>
                <br />
                <br />
                <h4>AU National Competition Entry</h4>
                <p>All state-selected Junior and Senior teams will compete in the Australian National Competition on <strong>28th March, 2026</strong>, hosted at <strong>Glenunga International High School, Adelaide</strong>.</p>
                <br />
                <br />
                <h4>📌 Notes</h4>
                <ul>
                  <li>✅ There is no participation fee.</li>
                  <li>✅ Teams must provide their own robotics kits.</li>
                  <li>✅ All participants must complete media & image rights consent as part of the forms.</li>
                  <li>✈️ Travel, visas, and accommodation for the Global Finale (Geneva, July 2026) are self-funded (sponsorship support may be available).</li>
                </ul>
                <br />
                <br />
                <h4 className="m-t30">📥 Quick Links</h4>
                <div className="d-flex flex-column gap-3 m-t10" style={{ maxWidth: 400 }}>
                  <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSe7UbAeK-2_UrKrLRtaUchsIo9cMHpvCsR_14M1BJwJLzu46A/viewform?usp=dialog" className="btn btn-primary radius-xl m-lr10" style={{ width: "100%", minWidth: 0 }}>
                    👉 Form 1 – Senior Team Application
                  </a>
                  <br />
                  <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSdIZgZH-yVb-tk06b8EI4AokAyKCSdyehe4O09auaUS_wy7oQ/viewform?usp=dialog" className="btn btn-success radius-xl m-lr10" style={{ width: "100%", minWidth: 0 }}>
                    👉 Form 2 – Junior Team Application
                  </a>
                  <br />
                  <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSdDYTcSEFFeZzfectAnGfbfIVeGOK856Nmit-jSyVf5HtdAfw/viewform?usp=dialog" className="btn btn-outline-dark radius-xl m-lr10" style={{ width: "100%", minWidth: 0 }}>
                    👉 Form 3 – Parental/Guardian Consent
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* END How to Apply */}
      </>
    )
  }

  robotics2026Content() {
    const { t } = this.props;
    return (
      <>
        <div className="section-full content-inner bg-white m-t30">
          <div className="container">
            <div className="section-head style-1 text-center">
              <h2 className="title">
                {t("Robotics_For_Good_2026_Application_H")}
              </h2>
            </div>

            <div className="row"></div>
            <div className="row">
              <div className="col-lg-12">
                <h4>{t("Robotics_For_Good_2026_Application_Content_P1_H")}</h4>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P1_1")}
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P1_2")}</strong>
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P1_3")}
                </p>
              </div>

              <Divider />

              <div className="col-lg-12">
                <h4>{t("Robotics_For_Good_2026_Application_Content_P2_H")}</h4>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P2_1")}
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P2_2")}</strong>
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P2_3")}
                </p>

                <ul style={{ marginTop: "10px", paddingLeft: "30px" }}>
                  <li><strong>{t("Robotics_For_Good_2026_Application_Content_P2_4")}</strong></li>
                  <li><strong>{t("Robotics_For_Good_2026_Application_Content_P2_5")}</strong></li>
                </ul>

                <h5>{t("Robotics_For_Good_2026_Application_Content_P2_6")}</h5>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P2_7")}
                </p>

                <ul style={{ marginTop: "10px", paddingLeft: "30px" }}>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P2_8")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P2_9")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P2_10")}</li>
                </ul>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P2_11")}
                </p>

                <ul style={{ marginTop: "10px", paddingLeft: "30px" }}>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P2_12")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P2_13")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P2_14")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P2_15")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P2_16")}</li>
                </ul>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P2_17")}
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P2_18")}</strong>
                  {t("Robotics_For_Good_2026_Application_Content_P2_19")}
                </p>

                <p>
                  <a
                    href="/static/pdf/Full_Robotics_Challenge.pdf"
                    target="_blank"
                    style={{ textDecoration: 'underline', color: 'rgb(51, 126, 187)' }}
                    rel="noreferrer"
                  >
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P2_20")}</strong>
                  </a>
                </p>

                {/* Video 1 */}
                <div style={{ textAlign: "center", margin: "20px auto" }}>
                  <div
                    style={{
                      position: "relative",
                      width: "90%",
                      maxWidth: "750px",
                      margin: "0 auto",
                      paddingBottom: "42.20%",
                      height: 0,
                      overflow: "hidden",
                    }}
                  >
                    <iframe
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        border: 0,
                      }}
                      title={t("Robotics_For_Good_2026_Application_Content_P2_20")}
                      src="https://youtube.com/embed/1RP7vAY94Kk?si=dsi_JhTZKYHfCURR"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>

                <p className="mt-4">
                  <a
                    href="/static/pdf/Rulebook-2026-2027-Health-Emergencies.pdf"
                    target="_blank"
                    style={{ textDecoration: 'underline', color: 'rgb(51, 126, 187)' }}
                    rel="noreferrer"
                  >
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P2_21")}</strong>
                  </a>
                </p>

              </div>

              <Divider />

              <div className="col-lg-12">
                <h4>{t("Robotics_For_Good_2026_Application_Content_P3_H")}</h4>

                <p>
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P3_1")}</strong>
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P3_2")}
                </p>

                <ul style={{ marginTop: "10px", paddingLeft: "30px" }}>
                  <li><strong>{t("Robotics_For_Good_2026_Application_Content_P3_3")}</strong></li>
                  <li><strong>{t("Robotics_For_Good_2026_Application_Content_P3_4")}</strong></li>
                </ul>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P3_5")}
                </p>

                <h5>{t("Robotics_For_Good_2026_Application_Content_P3_6")}</h5>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P3_7")}
                </p>

                <ul style={{ marginTop: "10px", paddingLeft: "30px" }}>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P3_8")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P3_9")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P3_10")}</li>
                </ul>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P3_11")}
                </p>

                <ul style={{ marginTop: "10px", paddingLeft: "30px" }}>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P3_12")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P3_13")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P3_14")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P3_15")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P3_16")}</li>
                </ul>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P3_17")}
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P3_18")}
                </p>
                <p>
                  <a
                    href="/static/pdf/Mission_Challenge.pdf"
                    target="_blank"
                    style={{ textDecoration: 'underline', color: 'rgb(51, 126, 187)' }}
                    rel="noreferrer"
                  >
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P3_19")}</strong>
                  </a>
                </p>
              </div>

              <Divider />

              <div className="col-lg-12">
                <h4>{t("Robotics_For_Good_2026_Application_Content_P4_H")}</h4>

                <p>
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P4_1")}</strong>
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P4_2")}
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P4_3")}</strong>
                  {t("Robotics_For_Good_2026_Application_Content_P4_4")}
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P4_5")}
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P4_6")}
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P4_7")}
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P4_8")}
                </p>

                <h5>{t("Robotics_For_Good_2026_Application_Content_P4_9")}</h5>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P4_10")}
                </p>

                <ul style={{ marginTop: "10px", paddingLeft: "30px" }}>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P4_11")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P4_12")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P4_13")}</li>
                </ul>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P4_14")}
                </p>

                <ul style={{ marginTop: "10px", paddingLeft: "30px" }}>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P4_15")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P4_16")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P4_17")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P4_18")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P4_19")}</li>
                </ul>
                <p>
                  <a
                    href="/static/pdf/AI_&_Technology_for_Health_Innovation_Challenge.pdf"
                    target="_blank"
                    style={{ textDecoration: 'underline', color: 'rgb(51, 126, 187)' }}
                    rel="noreferrer"
                  >
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P4_20")}</strong>
                  </a>
                </p>
              </div>
            </div>

            <Divider />

            <div className="row">
              <div className="col-lg-12">
                <h4>{t("Robotics_For_Good_2026_Application_Content_P5_H")}</h4>

                <h5>{t("Robotics_For_Good_2026_Application_Content_P5_1")}</h5>
                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P5_2")}
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P5_3")}</strong>
                </p>

                <h5>{t("Robotics_For_Good_2026_Application_Content_P5_4")}</h5>
                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P5_5")}
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P5_6")}</strong>
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P5_7")}
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P5_8")}</strong>
                  {t("Robotics_For_Good_2026_Application_Content_P5_9")}
                </p>
              </div>
            </div>

            <Divider />

            <div className="row">
              <div className="col-lg-12">
                <h4 className="mb-4">{t("Robotics_For_Good_2026_Application_Content_P6_H")}</h4>

                <div className="mb-4">
                  <p className="mb-1">
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P6_1")}</strong>
                    {t("Robotics_For_Good_2026_Application_Content_P6_2")}
                  </p>
                </div>

                <div className="mb-4">
                  <h5 className="mb-2">{t("Robotics_For_Good_2026_Application_Content_P6_3")}</h5>
                  <p className="mb-0">
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P6_4")}</strong>
                  </p>
                </div>

                <div className="mb-4">
                  <h5 className="mb-2">{t("Robotics_For_Good_2026_Application_Content_P6_5")}</h5>
                  <p className="mb-0">
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P6_6")}</strong>
                    <br />
                    {t("Robotics_For_Good_2026_Application_Content_P6_7")}
                    <br />
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P6_8")}</strong>
                  </p>
                </div>

                <div className="mb-4">
                  <h5 className="mb-2">{t("Robotics_For_Good_2026_Application_Content_P6_9")}</h5>
                  <p className="mb-0">
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P6_10")}</strong>
                    <br />
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P6_11")}</strong>
                    <br />
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P6_12")}</strong>
                  </p>
                </div>

                <div className="mb-4">
                  <h5 className="mb-2">{t("Robotics_For_Good_2026_Application_Content_P6_13")}</h5>
                  <p className="mb-0">
                    <strong>{t("Robotics_For_Good_2026_Application_Content_P6_14")}</strong>
                    <br />
                    <i>{t("Robotics_For_Good_2026_Application_Content_P6_15")}</i>
                  </p>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-lg-12">
                <h4>{t("Robotics_For_Good_2026_Application_Content_P7_H")}</h4>

                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th>{t("Robotics_For_Good_2026_Application_Content_P7_1")}</th>
                      <th>{t("Robotics_For_Good_2026_Application_Content_P7_2")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>{t("Robotics_For_Good_2026_Application_Content_P7_3")}</td>
                      <td>{t("Robotics_For_Good_2026_Application_Content_P7_4")}</td>
                    </tr>

                    <tr>
                      <td>{t("Robotics_For_Good_2026_Application_Content_P7_5")}</td>
                      <td>{t("Robotics_For_Good_2026_Application_Content_P7_6")}</td>
                    </tr>

                    <tr>
                      <td>{t("Robotics_For_Good_2026_Application_Content_P7_7")}</td>
                      <td>{t("Robotics_For_Good_2026_Application_Content_P7_8")}</td>
                    </tr>
                  </tbody>
                </table>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P7_9")}
                </p>

                <p>
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P7_10")}</strong>
                </p>


              </div>
            </div>

            <Divider />

            <div className="row">
              <div className="col-lg-12">
                <h4>{t("Robotics_For_Good_2026_Application_Content_P8_H")}</h4>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P8_1")}
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P8_2")}
                </p>

                <ul style={{ marginTop: "10px", paddingLeft: "30px" }}>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P8_3")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P8_4")}</li>
                  <li>{t("Robotics_For_Good_2026_Application_Content_P8_5")}</li>
                </ul>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P8_6")}
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P8_7")}</strong>
                  {t("Robotics_For_Good_2026_Application_Content_P8_8")}
                </p>

                <p>
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P8_9")}</strong>
                </p>

                <p>
                  {t("Robotics_For_Good_2026_Application_Content_P8_10")}
                </p>

                <h5 className="m-t40">{t("Robotics_For_Good_2026_Application_Content_P8_11")}</h5>
                <div className="d-flex flex-column gap-3 m-t10" style={{ maxWidth: 400 }}>
                  <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLScVdE23SHdFobHRkXhWOupLryKgQqFGRiErfGTnwTGkvCxfYQ/viewform?usp=header" className="btn btn-primary radius-xl m-lr10" style={{ width: "100%", minWidth: 0 }}>
                    {t("Robotics_For_Good_2026_Application_Content_P8_12")}
                  </a>
                  <br />
                  <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLScC30h6VknMx8lzSEnRZZTf6Z6Jk3k5LvgXs1-txG4Eg0AF3w/viewform?usp=header" className="btn btn-success radius-xl m-lr10" style={{ width: "100%", minWidth: 0 }}>
                    {t("Robotics_For_Good_2026_Application_Content_P8_13")}
                  </a>
                  <br />
                  <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLScb1PO5xySLB3VglTzhW_yswumMzjs2GQSz2tZnlbneGBOFWg/viewform?usp=header" className="btn btn-outline-dark radius-xl m-lr10" style={{ width: "100%", minWidth: 0 }}>
                    {t("Robotics_For_Good_2026_Application_Content_P8_14")}
                  </a>
                  <br />
                  <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSemGt_uOr91hmlIN125VHv9edR9Ye4UMnETKXaNBWLaoW1hLg/viewform?usp=header" className="btn btn-outline-dark radius-xl m-lr10" style={{ width: "100%", minWidth: 0 }}>
                    {t("Robotics_For_Good_2026_Application_Content_P8_15")}
                  </a>
                  <br />
                  <a target="_blank" rel="noopener noreferrer" href="/static/pdf/AAIO_2026-2027_Application_Consent.pdf" className="btn btn-outline-dark radius-xl m-lr10" style={{ width: "100%", minWidth: 0 }}>
                    {t("Robotics_For_Good_2026_Application_Content_P8_16")}
                  </a>
                </div>

                <Divider />

                <p>
                  <strong>{t("Robotics_For_Good_2026_Application_Content_P8_17")}</strong>
                </p>

              </div>
            </div>


          </div>
        </div>
      </>
    )
  }

  render() {
    const { t } = this.props;

    const { year } = this.props.match.params;

    return (
      <>
        <Header />
        <div className="page-content">
          <div className="content-block" id="content-area">
            {/* 🖼️ Banner */}
            <div
              className="page-banner"
              style={{ backgroundImage: `url(${bannerImg})` }}
            >
              <div className="container">
                <div className="page-banner-entry">
                  <h1 className="text-white">{t("Robotics_For_Good_Application_Title")}</h1>
                </div>
              </div>
            </div>

            {/* 🧭 Breadcrumb */}
            <div className="breadcrumb-row">
              <div className="container">
                <ul className="list-inline">
                  <li>
                    <Link to="/">{t("Robotics_For_Good_Application_LinkHome")}</Link>
                  </li>
                  <li>{t("Robotics_For_Good_Application_Link")}</li>
                </ul>
              </div>
            </div>

            {year === "2025" && this.robotics2025Content()}
            {year === "2026" && this.robotics2026Content()}


          </div>
        </div>
      </>
    );
  }
}

export default RoboticsForGoodApplication = withTranslation()(RoboticsForGoodApplication);
